import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import Backdrop from '@mui/material/Backdrop';
import { Dropdown } from 'primereact/dropdown'
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import TituloAtividadeService from '../../app/service/TituloAtividadeService'
import TituloAtividadeFaseService from '../../app/service/TituloAtividadeFaseService'

class TituloAtividade extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      titulo: null,
      titulos: [],
      codigo: '',
      nome: '',
      pontos: '',
      modalTitulo: false,
      modalTituloAlterar: false,
      openSpinner: false,
      //TitulosFases
      fases: [],
      fasesCadastro: [],
      fase: null,
      modalFase: false
    }

    this.tituloAtividadeService = new TituloAtividadeService();
    this.tituloAtividadeFaseService = new TituloAtividadeFaseService();

    this.acoes = this.acoes.bind(this);
    this.accept = this.accept.bind(this);
    this.renderFooterCadastroTitulos = this.renderFooterCadastroTitulos.bind(this);
    this.renderFooterAlterarTitulos = this.renderFooterAlterarTitulos.bind(this);
    this.renderFooterFase = this.renderFooterFase.bind(this);
    this.acoesfase = this.acoesfase.bind(this);
    this.onChangeCadastrarFase = this.onChangeCadastrarFase.bind(this);
  }

  listrFasesPorTitulos = async () => {
    await this.tituloAtividadeFaseService.listar(this.state.titulo.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarFasesNotInTitulo = async (titulo) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeFaseService.listarNotInTitulo(titulo,usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({fasesCadastro: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  associarFaseTitulo = async () => {
    if(this.state.fase == null) {
      this.toast.show({severity:'error', summary: 'Fase Título', detail:'Informe a Fase', life: 4000});
      return;
    }

    const tituloFase ={
      titulo: this.state.titulo,
      fase: this.state.fase
    };

    await this.tituloAtividadeFaseService.cadastrar(tituloFase)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Fase Título', detail:'Fase associada ao Título com sucesso', life: 4000});
        this.listrFasesPorTitulos();
        this.listarFasesNotInTitulo(this.state.codigo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async associarFaseTituloNovo(titulo){
    this.setState({openSpinner: true});
    await this.consultarTituloCadastroFase(titulo);
    this.setState({fase: null});
    await this.listrFasesPorTitulos();
    await this.listarFasesNotInTitulo(titulo.codigo);
    this.abrirModaAlterar('modalFase');
    this.setState({openSpinner: false})
  }

  async onChangeCadastrarFase(e) {
    await this.setState({fase: e.value});
    this.setState({openSpinner: true});
    await this.associarFaseTitulo();
    this.setState({openSpinner: false});
  }

  listarTitulos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({titulos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  limparCampos() {
    this.setState({titulo: null});
    this.setState({nome: ''});
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarTitulo(rowData)}
                tooltip="Editar Título" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-list" className="p-button-rounded p-button-text"
                onClick={() => this.associarFaseTituloNovo(rowData)} 
                tooltip="Fases de Atividade" 
                tooltipOptions={{position: 'top'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Título" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  acoesfase(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.excluirFase(rowData)} 
                tooltip="Excluir Fase" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  async excluirFase(fase) {
    this.setState({openSpinner: true});
    await this.tituloAtividadeFaseService.excluir(this.state.titulo.codigo,fase.codigo)
      .then(response => {
        this.listrFasesPorTitulos();
        this.listarFasesNotInTitulo(this.state.codigo);
        this.toast.show({severity:'success', summary: 'Fase Título', detail:'Fase excluída com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Fase Título', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  confirmaExclusao(titulo) {
    this.setState({codigo: titulo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o Título de Atividade selecionado?',
        header: 'Exclusão de Título de Atividade',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  excluirTitulo() {
    this.setState({openSpinner: true});
    this.tituloAtividadeService.excluir(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Títulos de Atividades', detail:'Título de Atividade excluído com sucesso', life: 4000});
        this.listarTitulos();
      });
      this.setState({openSpinner: false});
  }

  accept() {
    this.excluirTitulo();
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  renderFooterCadastroTitulos(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarTitulo}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterAlterarTitulos(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarTitulo}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterFase(name) {
    return (
        <div>
            <Button label="Fechar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  async consultarTitulo(titulo){
    this.setState({openSpinner: true});
    await this.tituloAtividadeService.consultar(titulo.codigo)
      .then(response => {
        this.setState({titulo: response.data});
        this.setState({nome: response.data.titulo});
        this.setState({codigo: response.data.codigo});
        this.setState({pontos: response.data.pontos});
        this.abrirModaAlterar('modalTituloAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async consultarTituloCadastroFase(titulo){
    this.setState({openSpinner: true});
    await this.tituloAtividadeService.consultar(titulo.codigo)
      .then(response => {
        this.setState({titulo: response.data});
        this.setState({nome: response.data.titulo});
        this.setState({codigo: response.data.codigo});
        this.setState({pontos: response.data.pontos});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  cadastrarTitulo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:'O nome do Título da Atividade é obrigatório', life: 4000});
      return;
    }
    const titulo = {
      titulo: this.state.nome,
      empresa: usuarioLogado.empresa,
      pontos: this.state.pontos
    }

    this.setState({openSpinner: true});
    await this.tituloAtividadeService.cadastrar(titulo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Títulos de Atividades', detail:'Título de Atividade cadastrado com sucesso', life: 4000});
        this.fecharModal('modalTitulo');
        this.listarTitulos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  alterarTitulo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:'O nome do Título da Atividade é obrigatório', life: 4000});
      return;
    }

    const titulo = {
      codigo: this.state.codigo,
      titulo: this.state.nome,
      empresa: usuarioLogado.empresa,
      pontos: this.state.pontos
    }

    this.setState({openSpinner: true});
    await this.tituloAtividadeService.alterar(titulo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Títulos de Atividades', detail:'Título de Atividade alterado com sucesso', life: 4000});
        this.fecharModal('modalTituloAlterar');
        this.listarTitulos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarTitulos();
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          {/**Cadastro de Títulos de Atividades */}
          <Dialog header="Cadastro de Títulos de Atividades"
                    visible={this.state.modalTitulo} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroTitulos('modalTitulo')} 
                    onHide={() => this.fecharModal('modalTitulo')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeRito">Nome</label>
                        <InputText id="nomeTitulo" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="pontos">Nome</label>
                        <InputText id="pontos" 
                                   type="text" 
                                   value={this.state.pontos}
                                   onChange={e => this.setState({pontos: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Títulos de Atividades */}
          <Dialog header="Alterar Títulos de Atividades"
                    visible={this.state.modalTituloAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarTitulos('modalTituloAlterar')} 
                    onHide={() => this.fecharModal('modalTituloAlterar')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeTituloAlterar">Nome</label>
                        <InputText id="nomeTituloAlterar" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="pontosAlterar">Nome</label>
                        <InputText id="pontosAlterar" 
                                   type="text" 
                                   value={this.state.pontos}
                                   onChange={e => this.setState({pontos: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Fases de Atividade */}
          <Dialog header="Fases de Atividade"
                    visible={this.state.modalFase} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterFase('modalFase')} 
                    onHide={() => this.fecharModal('modalFase')}>
                
                <div className="row">
                  <div className="col-md-12">
                    <div className="formGroup">
                      <strong>{this.state.nome}</strong>
                    </div>
                  </div>
                </div>
                <br/>
                <div className="row">
                  <div className="col-md-12">
                    <div className="formGroup">
                      <Dropdown value={this.state.fase} 
                                options={this.state.fasesCadastro} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                filter showClear filterBy="nome"
                                onChange={this.onChangeCadastrarFase}
                                id="fase"
                                placeholder="Selecionar fase para cadastro"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                </div>
                <br/>
                <div className="row">
                  <div className="col-md-12">
                    <div className="formGroup">
                      <DataTable value={this.state.fases}  paginator responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" 
                        emptyMessage="Nenhuma fase de atividade" 
                        rows={5}
                        size="small"
                        header="Fases cadastrada para este Título">
                        <Column field="nome" header="Fase"></Column>
                        <Column body={this.acoesfase} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                      </DataTable>
                    </div>
                  </div>
                </div>
          </Dialog>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-tablet"></i>
                        <span> Títulos de Atividades</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalTitulo')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="pi pi-check-square"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.titulos}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage="Nenhum título encontrado" rows={10}>
                      <Column field="titulo" header="Nome"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

TituloAtividade.contextType = AuthContext;
export default withRouter (TituloAtividade)